<div class="form-field email-group" [formGroup]="emailGroup" role="group">
  @if (name) {
    <span>{{ name }}</span>
  }

  <div class="email-group-inputs">
    <input type="text" class="form-control" [formControlName]="EmailParticle.LocalPart" (blur)="onTouched()">
    <select class="form-control" [formControlName]="EmailParticle.Domain" (blur)="onTouched()">
      @for (domain of domains; track domain) {
        <option [value]="domain">&#64;{{domain}}</option>
      }
    </select>
  </div>

  <ng-content></ng-content>
</div>
